var map = {
	"./icon-team-1.svg": "1d53",
	"./icon-team-2.svg": "9573",
	"./icon-team-3.svg": "9da1",
	"./icon-team-4.svg": "be15",
	"./icon-team-5.svg": "4f4d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c276";